import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { IncidentDetailPatient } from 'sections/ube/features/IncidentDetail/useIncidentDetailForUbe';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';

type Props = {
  findingsEmsTeamContact: IncidentDetailPatient['findingsEmsContact'];
};

export const FindingsEmsTeamContactView = ({
  findingsEmsTeamContact,
}: Props) => {
  if (!findingsEmsTeamContact) {
    return (
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <SectionTitle text="接触時所見" />
          <p>データが存在しません</p>
        </div>
      </BorderedContainer>
    );
  }

  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="接触時所見" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="接触時所見"
            content={<TagList tags={findingsEmsTeamContact.conditions} />}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="JUST7"
            content={<TagList tags={findingsEmsTeamContact.just7 ?? []} />}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="麻痺"
            content={
              [
                ...findingsEmsTeamContact.reveals?.paralysisParts,
                ...findingsEmsTeamContact.reveals?.paralysisSymptoms,
              ][0] ?? 'なし'
            }
          />
          <InfoDisplay
            title="痙攣"
            content={findingsEmsTeamContact.reveals?.spasmParts?.[0]}
          />
          <InfoDisplay
            title="出血"
            content={findingsEmsTeamContact.reveals?.bleedingType?.[0]}
          />
        </div>
      </div>
    </BorderedContainer>
  );
};
